/**
* @Author: zachalam
* @Date:   2017-01-19T14:32:33-08:00
 * @Last modified by:   Daniel
 * @Last modified time: 2017-04-17T14:54:45-07:00
*/

import React, { Component } from 'react';
import Container from '../../blocks/Container';
import { css, StyleSheet } from 'aphrodite/no-important';
import Panel from '../../common/Panel';
import Headline from '../../common/Headline'
import { dimensions, spacing, color } from '../../../style';
import { SUNSET_DATE } from '../../../config/Master';

const style = StyleSheet.create({
  packageList: {
    display: 'flex',
    justifyContent: 'center',

    [dimensions.SCREEN_MAX_SM]: {
      flexDirection: 'column'
    }
  },

  title: {
    ...spacing.MARGIN_BOTTOM_MD,
    ...spacing.MARGIN_TOP_MD,
    color: '#FFF',
    textAlign: 'center'
  },

  hero: {
    background: `linear-gradient(0deg, ${color.BRAND_1}, #34a7c1)`,
    ...spacing.PADDING_TOP_LG,
    ...spacing.PADDING_BOTTOM_LG
  }
})

class Billing extends Component {

  render() {
    return (
      <div>
        <div className={css(style.hero)} style={{ minHeight: '500px' }}>
          <Container>
            <div className={css(style.title)} style={{ marginTop: '100px' }}>
              <Headline hasDescription invertedColor size="LG">
                Miss Travel is saying goodbye!
              </Headline>
            </div>
          </Container>
          <Container fullWidth>
            <div className={css(style.packageList)}>
              <span>
                <Panel padding="large" extraStyles={{ width: '550px', textAlign: 'center' }}>
                  <Headline size="headline">
                    Our platform will sunset on {SUNSET_DATE}, and will no longer be accepting payments.<br /><br />We want to thank you for letting us be a part of your journeys.
                  </Headline>
                </Panel>
              </span>
            </div>
          </Container>
        </div>

      </div>
    );
  }
}

export default Billing;


// WEBPACK FOOTER //
// ./src/components/pages/Billing/Billing.jsx